import MojitoCore from 'mojito/core';
const ApiProvider = MojitoCore.Services.ApiProvider;

const log = MojitoCore.logger.get();

/**
 * Abstract favorites service to be implemented by different integrations.
 *
 * @class AbstractFavoritesService
 * @abstract
 * @memberof Mojito.Services.Favorites
 */
export default class AbstractQuickStartGuideService extends ApiProvider {
    /**
     * Fetch favorite events.
     *
     * @param {Function} successCallback - Success callback.
     * @param {Function} errorCallback - Error callback.
     * @returns {Promise} Fetch favorite events promise.
     *
     * @function Mojito.Services.Favorites.AbstractFavoritesService#fetchFavoriteEventIds
     */
    // eslint-disable-next-line no-unused-vars
    fetchFavoriteEventIds(successCallback, errorCallback) {
        log.error('fetchFavoriteEventIds must be implemented by concrete subclass!');
        return Promise.reject();
    }

    /**
     * Add event id to favorites.
     *
     * @param {string} eventId - Event id to add.
     * @returns {Promise} Add event id promise.
     *
     * @function Mojito.Services.Favorites.AbstractFavoritesService#addFavoriteEventId
     */
    // eslint-disable-next-line no-unused-vars
    addFavoriteEventId(eventId) {
        log.error('addFavoriteEventId must be implemented by concrete subclass!');
        return Promise.reject();
    }

    /**
     * Remove event id from favorites.
     *
     * @param {string} eventId - Event id to remove.
     * @returns {Promise} Remove event id promise.
     *
     * @function Mojito.Services.Favorites.AbstractFavoritesService#removeFavoriteEventId
     */
    // eslint-disable-next-line no-unused-vars
    removeFavoriteEventId(eventId) {
        log.error('removeFavoriteEventId must be implemented by concrete subclass!');
        return Promise.reject();
    }
}
